<footer id="footer" [ngClass]="{ 'miniplayer-margin': showMiniPlayer }" class="page-footer font-small unique-color-dark">
  <div class="footer-copyright text-center py-3">
    <div class="copyright d-inline-block">
      © {{year}} Copyright: Audalize Music
      <div class="version">v.{{buildVersion}}</div>
    </div>
  </div>

</footer>
